<template>
  <main class="p20 bg-white main">
    <div class="mt20 mb20">
      <span class="title1">到库管理</span>
    </div>
    <div class="tr mb10">
      <router-link to='/zhongzhuanbuhuo/in/forecast' class="btn-scan ivu-btn ivu-btn-primary">到库预报
      </router-link>
    </div>
    <div class="search-one" style="margin-top: 10px;">
      <div class="search-item">
        快递单号<Input class='ml10 mr20' style="width: 200px;" v-model="screen_data.waybill_code" placeholder="请输入快递单号" />
      </div>
      <div class="search-item">
        状态
        <Select v-model="screen_data.status" class='ml10 mr20' style="width: 120px;">
          <Option v-for="(option, index) in statusList" :value="option.value" :key="index">{{option.label}}</Option>
        </Select>
      </div>
      <div class="search-item">
        创建日期
        <DatePicker @on-change="sDateChange" type="date" class='ml10 mr20 w200'></DatePicker>-
        <DatePicker @on-change="eDateChange" type="date" class='ml10 mr20 w200'></DatePicker>
      </div>
      <div class="search-item">
        <button class="ivu-btn ivu-btn-primary fr ml20" @click="gotoImport">导入补全包裹</button>
        <button class="ivu-btn ivu-btn-primary fr ml20" @click="exportData">导出待补全包裹</button>
        <button class="ivu-btn ivu-btn-primary fr" @click="search">搜索</button>
      </div>
    </div>
    <Table :loading="loading" class="mt20" border :columns="table_data.columns" :data="table_data.data">
      <template slot-scope="{ row, index }" slot="images">
        <span class="item-img mr10 fl" v-for="(v,i) in row.image_arr" :key="i" :src="v">
          <el-image style="width: 30px; height: 30px;margin-top: 10px;" :src="v" :preview-src-list="row.image_arr">
          </el-image>
        </span>
      </template>
    </Table>
    <Paging :page-data="page_data" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>
    <Modal :title="'入库单号为'+detailInfo.waybill_code+'的详情'" v-model="show_detail" width="1000">
      <div class="details f14">
        <p class="mt10">客户编号 {{detailInfo.client_code}}</p>
        <p class="mt10">客户姓名 {{detailInfo.client_user_name}}</p>
      </div>
      <Table class="mt20" border :columns="detail_columns" :data="detail_list">

      </Table>
      <div slot="footer"></div>
    </Modal>
  </main>
</template>

<script>
  import Paging from '@/components/common/paging';
  export default {
    components: {
      Paging,
    },
    data() {
      return {
        error_msg: '', //错误信息
        sku: '', //正在扫描的sku
        sku_data: {}, //sku
        show_edit: false, //编辑sku
        show_update: false, //更新内含物弹框
        detail_list: [],
        detailInfo: {},
        show_detail: false,
        form_data: {},
        table_data: { //列表数据
          columns: [],
          data: []
        },
        category: [],
        website: [],
        loading: true, //是否加载中
        screen_data: { //传入接口的搜索条件
          pageNum: 1,
          pageSize: 10,
          warehouse_id: '',
          biz_type: 0
        },
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
        statusList: [{
          value: '',
          label: '全部'
        }, {
          value: -1,
          label: '预报待入库'
        }, {
          value: 0,
          label: '入库中'
        }, {
          value: 1,
          label: '已入库'
        }],
        sku_columns: [{
          title: 'SKU',
          key: 'sku',
          width: 200,
        }, {
          title: '已扫描数量',
          key: 'count',
          width: 200,
        }, {
          title: "操作",
          key: "im_name",
          width: 200,
          render: (h, params) => {
            let doms = [];
            doms.push(h('button', {
              'class': "fc-blue",
              style: {
                marginRight: '10px'
              },
              on: {
                click: () => {
                  this.sku_data = {
                    ...params.row
                  };
                  this.show_edit = true
                  // this.showEdit(params.index)
                }
              }
            }, '编辑'));
            doms.push(h('button', {
              'class': "fc-red",
              style: {
                marginRight: '10px'
              },
              on: {
                click: () => {
                  this.sku_data = params.row;
                  this.delSku()
                }
              }
            }, '删除'));
            return h("div", doms);
          }
        }],
        detail_columns: [{
          title: 'UPC',
          key: 'sku',
          width: 200,
        }, {
          title: '商品名称',
          key: 'product_name',
        }, {
          title: '入库数量',
          key: 'count',
          width: 80,
        }, {
          title: '备注',
          key: 'remark',
        }]
      }
    },
    methods: {
      init() {
        this.table_data.columns = this.setColumns();
      },
      waybillChanged(e, name) {
        this.sku = e.target.value.toUpperCase()
      },

      sDateChange(e) {
        if (e) {
          this.screen_data.create_start_date = e + ' 00:00:00'
        } else {
          this.screen_data.create_start_date = ''
        }
      },
      eDateChange(e) {
        if (e) {
          this.screen_data.create_end_date = e + ' 23:59:59'
        } else {
          this.screen_data.create_end_date = ''
        }
      },
      getDetail(waybill_code) { //查看详情
        this.$axios.get("/warehouse/waybill/detail", {
          params: {
            waybill_code: waybill_code
          }
        }).then(res => {
          if (res.success && res.data && res.data.length) {
            res.data.forEach(v => {
              v.image_arr = []
              if (v.image_urls) {
                v.image_arr = v.image_urls.split(',')
              }
            })
            this.detail_list = res.data;
          }
          this.show_detail = true;
        })
      },

      /*
       * 搜索
       */
      search() {
        this.screen_data.pageNum = 1;
        this.getList();
      },
      exportData() {
        this.$axios.get("/warehouse/waybill/empty/excel/export", {
          params: this.screen_data
        }).then(res => {
          if (res.success && res.data) {
            let a = document.createElement('a'); //创建一个<a></a>标签
            a.href = res.data; //赋值url
            a.download = res.data; //文件名称
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click(); //点击下载
            a.remove(); //删除标签
            this.$Message.info('下载成功');
          }
        })
      },
      gotoImport() {
        this.$router.replace({
          path: "/zhongzhuanbuhuo/in/import"
        });

      },
      /*
       * 分页
       */
      setPage(page) {
        this.screen_data.pageNum = this.page_data.pageIndex = page;
        this.getList();
      },
      chooseSize(size) {
        this.page_data.pageSize = this.screen_data.pageSize = size;
        let p = Math.ceil(this.page_data.dataTotal / this.page_data.pageSize);
        if (this.page_data.pageIndex > p) {
          this.page_data.pageIndex = this.screen_data.pageNum = p;
        }
        this.getList();
      },
      /*
       * 获取列表
       */
      getList() {
        this.$axios.get("/warehouse/waybill/list", {
          params: this.screen_data
        }).then(res => {
          this.loading = false;
          if (res.success && res.data && res.data.length) {
            this.table_data.data = res.data;
          } else {
            this.table_data.data = []
          }
          this.page_data.pageTotal = res.pageTotal;
          this.page_data.dataTotal = res.totalSize;
        })
      },
      setColumns() {
        let arr = [];
        arr = [{
          title: '快递单号',
          key: 'waybill_code',
          tooltip: true,
          minWidth: 200,
          fixed: 'left'
        }, {
          title: 'SKU',
          key: 'sku',
          minWidth: 200,
          align: 'center',
          fixed: 'left'
        }, {
          title: '商品名称',
          key: 'product_name',
          minWidth: 200,
          tooltip: true,
        }, {
          title: '商品数',
          key: 'product_count',
          minWidth: 120,
          render: (h, params) => {
            if (params.row.product_count == 0) {
              return h("span", "-");
            } else {
              return h("span", params.row.product_count);
            }
          }
        }, {
          title: '状态',
          key: 'status',
          minWidth: 120,
          render: (h, params) => {
            let text = "";

            switch (params.row.status) {
              case -1:
                text = "预报待入库";
                break;
              case 0:
                text = "入库中";
                break;
              case 1:
                text = "已入库";
                break;
            }

            return h("span", text);
          }
        }, {
          title: '客户编号',
          key: 'client_code',
          tooltip: true,
          minWidth: 100,
        }, {
          title: '客户姓名',
          key: 'client_user_name',
          tooltip: true,
          minWidth: 200,
        }, {
          title: '创建时间',
          key: 'create_date',
          width: 190,
          tooltip: true,
        }, {
          title: '操作',
          fixed: 'right',
          minWidth: 200,
          render: (h, params) => {
            let doms = [];
            doms.push(h('span', {
              style: {
                cursor: "pointer",
                color: "#0062da"
              },
              on: {
                click: () => {
                  this.detailInfo = params.row;
                  this.getDetail(params.row.waybill_code)
                }
              }
            }, ' 商品详情'));

            if (params.row.status == 1 && params.row.product_count == 0) {
              doms.push(h('span', {
                style: {
                  cursor: "pointer",
                  color: "#0062da",
                  'margin-left': '15px'
                },
                on: {
                  click: () => {
                    this.$router.push({
                      path: '/zhongzhuanbuhuo/in/sku/update?waybill_code=' + params.row.waybill_code
                    })

                  }
                }
              }, '补全内含物'));
            }

            return h("div", doms);
          }
        }];
        return arr;
      },
      waybillChanged2(e, name) {
        alert(name)
        this.form_data[name] = e.target.value.toUpperCase()
      },
    },
    created() {
      this.screen_data.warehouse_id = localStorage.getItem('warehouse_id')
      this.screen_data.client_code = localStorage.getItem('client_code') || ''

      if (this.screen_data.warehouse_id) {
        this.getList();
      } else {
        this.$Message.info('请选择仓库')
      }
      this.init();
    }
  }
</script>

<style scoped>
  .ivu-modal-wrap,
  .ivu-modal-mask {
    z-index: 99 !important;
  }

  .btn-scan:visited,
  .btn-scan:active,
  .btn-scan:focus {
    color: #ffffff;
  }

  .btn-scan {
    line-height: 35px;
    margin-top: 10px;
  }

  .inbill-code {
    width: 600px;
    padding: 20px 0;
    text-align: center;
    font-size: 20px;
    background-color: #f6f8f9;
    margin-bottom: 20px;
  }

  .client-code {
    width: 200px;
    padding: 10px 30px;
    font-size: 15px;
    background-color: #f6f8f9;
  }

  .client-code span {
    display: inline-block;
    font-size: 30px;
    padding: 10px 0;
    font-weight: bold;
  }

  .btn-print {
    padding: 10px 30px;
    height: auto;

  }
</style>



// WEBPACK FOOTER //
// src/pages/zhongzhuanbuhuo/in/list.vue